import { css } from 'lit';

var css_248z = css`:host{--tab-panel-padding-y:1rem;display:block}.tab-panel{display:block;padding:var(--tab-panel-padding-y) 0}.tab-panel:not(.tab-panel--active){display:none}`;

export { css_248z as default };
//# sourceMappingURL=sgds-tab-panel2.js.map
